// @story: libs/storybook/stories/modules/auth/entity-access-host.stories.ts
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs';
import type { EntityType } from '@zag/auth/models';

@Component({
  selector: 'sc-entity-access-host',
  imports: [],
  templateUrl: './entity-access-host.component.html',
  styleUrl: './entity-access-host.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EntityAccessHostComponent {
  readonly entityType = input.required<EntityType>();

  private readonly rawEntityId = toSignal(inject(ActivatedRoute).paramMap.pipe(map(params => params.get('id'))));

  readonly entityId = computed<string>(() => this.rawEntityId() ?? '');
}
